import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { companies } from "./companies";

// ============================================================================
// branches — สาขาภายใต้ company
// ============================================================================
export const branches = sqliteTable("core_branches", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull().references(() => companies.id), // FK → companies
  name: text("name").notNull(),
  branchNo: text("branch_no"),
  address: text("address"),
  phone: text("phone"),
  isActive: integer("is_active").notNull().default(1), // เปิด/ปิดใช้งาน
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

// Type exports
export type Branch = typeof branches.$inferSelect;
export type NewBranch = typeof branches.$inferInsert;
